import React, { useState, useEffect } from 'react'
import { act } from 'react-dom/test-utils'
import bdlogo from '../../../public/bdlogo.webp'
import deckCarousel1 from '../../../public/deck-carousel-1.webp'
import deckCarousel2 from '../../../public/deck-carousel-2.webp'
import deckCarousel3 from '../../../public/deck-carousel-3.gif'
import deckGrid1 from '../../../public/deck-grid-1.webp'
import deckGrid2 from '../../../public/deck-grid-2.webp'
import deckGrid3 from '../../../public/deck-grid-3.webp'
import deckGrid4 from '../../../public/deck-grid-4.webp'

function Homepage() {
  const [activeImage, setActiveImage] = useState(0)

  useEffect(() => {
    setActiveImage(deckCarousel1)
  }, [])

  return (
    <div className='homepage-container'>
      <div className='homepage-header'>
        <div className='site-logo'>
          <img src={bdlogo} alt='brand-deck-logo' />
        </div>
      </div>
      <div className='homepage-product-wrapper'>
        <div className='homepage-product-grid-wrapper'>
          <div className='homepage-product-left '>
            <div className='main-image-container'>
              <img src={activeImage} alt='' />
            </div>
            <div className='thumbnail-image-container'>
              <button
                className='thumbnail-image-button'
                onClick={() => setActiveImage(deckCarousel1)}
              >
                <img
                  className='thumbnail-image-single'
                  src={deckCarousel1}
                  alt=''
                />
              </button>
              <button
                className='thumbnail-image-button'
                onClick={() => setActiveImage(deckCarousel2)}
              >
                <img
                  className='thumbnail-image-single'
                  src={deckCarousel2}
                  alt=''
                />
              </button>
              <button
                className='thumbnail-image-button '
                onClick={() => setActiveImage(deckCarousel3)}
              >
                <img
                  className='margin-zero thumbnail-image-single '
                  src={deckCarousel3}
                  alt=''
                />
              </button>
            </div>
          </div>
          <div className='homepage-product-right grid-item'>
            <h1 className='product-header'>Brand Deck Digital</h1>
            <div className='product-description'>
              <p className='product-content-text'>
                Start building your brand today, using this simple tool to
                determine who you are and who you're not. Now online.
              </p>
              <p className='product-content-text'>- Real time collaboration</p>
              <p className='product-content-text'>
                - No accounts or logins so you can easily invite others
              </p>
              <p className='product-content-text'>
                - Annual subscription, cancel any time
              </p>
            </div>
            <a href='/checkout' className='homepage-button'>
              Buy now
            </a>
          </div>
        </div>
        <hr className='homepage-section-line' />
        <div className='homepage-product-collection-wrapper'>
          <div className='homepage-product-collection-header'>
            <p>More Decks</p>
          </div>
          <div className='homepage-product-collection-content'>
            <div className='product-grid-item'>
              <a
                className='product-single'
                href='https://branding.cards/products/brand-deck-standard'
              >
                <div className='homepage-image-wrapper'>
                  <img src={deckGrid1} alt='deck-product-1' />
                </div>
                <h3 className='homepage-product-text'>Brand Deck</h3>
                <div className='homepage-product-price'>
                  <p>$25.00</p>
                </div>
              </a>
            </div>
            <div className='product-grid-item'>
              <a
                className='product-single'
                href='https://branding.cards/products/brand-deck-combo-pack'
              >
                <div className='homepage-image-wrapper'>
                  <img src={deckGrid2} alt='deck-product-1' />
                </div>
                <h3 className='homepage-product-text'>Brand Deck Combo Pack</h3>
                <div className='homepage-product-price'>
                  <p>$45.00</p>
                </div>
              </a>
            </div>
            <div className='product-grid-item'>
              <a
                className='product-single'
                href='https://branding.cards/products/brand-deck-digital'
              >
                <div className='homepage-image-wrapper'>
                  <img src={deckGrid3} alt='deck-product-1' />
                </div>
                <h3 className='homepage-product-text'>Brand Deck Digital</h3>
                <div className='homepage-product-price'>
                  <p>$50.00</p>
                </div>
              </a>
            </div>
            <div className='product-grid-item'>
              <a
                className='product-single'
                href='https://branding.cards/products/brand-deck-nsfw'
              >
                <div className='homepage-image-wrapper'>
                  <img src={deckGrid4} alt='deck-product-1' />
                </div>
                <h3 className='homepage-product-text'>
                  Brand Deck NSFW Edition
                </h3>
                <div className='homepage-product-price'>
                  <p>$25.00</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Homepage
